import { codesToPermissions } from "./constants";
import { Pcode, Permission } from "./types";

// function to get the list of permissions from the list of pcodes
export const getPermissionsFromPcodes = (pcodes: Pcode[]): Permission[] => pcodes.map((pcode) => codesToPermissions[pcode]);
